import { observer } from 'mobx-react';
import { T } from '../../../Translations';
import ToastStore from '../Store';

interface Props {
  store: ToastStore;
}

const undo = (store: ToastStore) => () => store.undo();

function UndoButton({ store }: Props) {
  return (
    <button
      type="button"
      onClick={undo(store)}
      className="rounded-md px-2 py-1 hover:underline focus:outline-none focus:ring-2 focus:ring-ring"
      style={{ fontWeight: 'var(--font-weight-semibold)', color: 'var(--accent)' }}
      data-intercom-target="toast-undo-button"
    >
      <T kind="Undo" />
    </button>
  );
}

export default observer(UndoButton);
